const americanTransloadingSolutions = {
  id: "18567be7-5e38-4a33-b947-f380620326c1",
  greg: "3ed552aa-f380-4faf-af45-30470168f78f",
  manny: "623ab185-e463-4331-b09c-1bd62444ffbb",
};

export const customLogic = () => {
  const appUser = window.appUser;

  if (appUser.reloadYardId === americanTransloadingSolutions.id) {
    if (
      appUser.id !== americanTransloadingSolutions.greg &&
      appUser.id !== americanTransloadingSolutions.manny
    ) {
      return true;
    }
  }

  return false;
};
